import { useTranslation } from "react-i18next";
import card from "../tools/ToolCard.module.css";

/**
 * How many of a group's people have reached a spending limit, and how many are near one, as chips in the group status
 * colours: red for reached, amber for near. Renders nothing when nobody is either.
 *
 * @param props.reached - How many people have spent a whole limit or more.
 * @param props.near - How many are at 90% of a limit or more, but not yet at it.
 * @param props.className - An extra class for each chip, so a caller can style them in place.
 */
export function PeopleLimitChips({ reached, near, className = "" }: { reached: number; near: number; className?: string }): React.JSX.Element | null {
  const { t } = useTranslation();
  if (reached === 0 && near === 0) {
    return null;
  }

  return (
    <>
      {reached > 0 && <span className={`${card.chip} ${card.chipDanger} ${className}`}>{t("myGroups.limits.reached", { count: reached })}</span>}
      {near > 0 && <span className={`${card.chip} ${card.chipWarning} ${className}`}>{t("myGroups.limits.near", { count: near })}</span>}
    </>
  );
}
